<template>
	<div
		class="field"
		:class="{
			'input': type !== 'textarea',
			'textarea': type === 'textarea',
			'input-prefix': this.$slots.prefix,
			'input-suffix': this.$slots.suffix,
			'input-prepend': this.$slots.prepend,
			'input-append': this.$slots.append,
			'focus':inputFocused,
			'value':value!==null && value!=='',
			'label':label
		}">

		<span v-if="$slots.default" class="slot">
			<slot />
		</span>

		<input
			:id="inputId"
			class="inner"
			:name="name"
			:type="type"
			:value.trim="value"
			:placeholder="placeholder"
			:disabled="disabled"
			:readonly="readonly"
			:max="max"
			:min="min"
			:tabindex="tabindex"
			:autocomplete="autocomplete"
			:autocapitalize="autocapitalize"
			@keyup="$emit('keyup', $event)"
			@blur="onBlur"
			@focus="$emit('focus')"
			@input="onInput">

		<div v-if="$slots.suffix" class="suffix">
			<slot name="suffix" />
		</div>
<!--		<div v-if="$slots.append && type !== 'textarea'" class="append">-->
<!--			<slot name="append" />-->
<!--		</div>-->
	</div>
</template>

<script>
	import {fr} from 'vuejs-datepicker/dist/locale'
	// import Datepicker from 'vuejs-datepicker';

	export default {
		name: 'VueInput',
		components:{
			// Datepicker,
		},

		model: {
			prop: 'value',
			event: 'input'
		},
		props: {
			label:{},//présence de label
			inputId:{},
			type: {
				type: String,
				default: 'text'
			},
			// value: [String, Number],
			value: {},
			name: String,
			readonly: {
				type: Boolean,
				default: false
			},
			autocomplete: {
				type: [String, Boolean],
				default: false
			},
			autocapitalize: {
				type: [String, Boolean],
				default: false
			},
			min: Number,
			max: Number,
			placeholder: String,
			tabindex: {},
			disabled: {
				type: Boolean,
				default: false
			},
			rows: {
				type: Number,
				default: 3
			}
		},

		data(){
			return {
				inputFocused:false,
				uid:this._uid,
				fr: fr,
			}
		},

		methods: {
			onBlur:function(){
				this.$emit('blur');
				// console.log("onBlur vueInput");
				// this.$emit('focused', false);
				// this.inputFocused = false;
			},
			// onFocus:function(){
			// 	// this.inputFocused = true;
			// 	this.$emit('focus');
			// },
			onInput (e) {
				// if(e.target && e.target.value){
					this.$emit('input', e.target.value)
				// }else{
				// 	this.$emit('input', e)
				// }
			}
		}
	}
</script>

<style lang="scss">
	@import './scss/variables';
	@import './scss/mixins';
	@import '../../assets/less/variables.scss';


	.vdp-datepicker__calendar {
		width: 100%;
		max-width: 300px;
		bottom: 100%;
		left: -1px;
		right: -1px;
		margin: auto;
		header {
			line-height: 25px;
		}
		.cell {
			padding: 1px;
			height: inherit;
			line-height: inherit;
			border-radius:10px
		}
	}

	.field{
		display: flex;
		input{
			flex-grow: 1;
		}

		.suffix{
			padding-right: 10px;
		}
	}

	.slot{
		padding: 0 10px;
		cursor: not-allowed;
		@extend .ellipsis;
		@include no-select();
	}

	.input {
		$r: &;

		/*&.label{*/
			/*.inner{*/
			/*	padding: 15px 15px 0;*/
			/*}*/
		/*}*/
		/*.prefix,*/
		/*.suffix {*/
			/*<!--color: $color-text-regular;-->*/
			/*position: absolute;*/
			/*top: 0;*/
			/*bottom: 0;*/
			/*width: 40px;*/
			/*display: flex;*/
			/*align-items: center;*/
			/*justify-content: center;*/
			/*z-index: 10;*/
		/*}*/
		/*.prefix {*/
		/*	left: 0;*/
		/*}*/

		.prepend {
			display: table-cell;
			border-left: $input-border;
			border-top: $input-border;
			border-bottom: $input-border;
			color: $color-text-faded-low;
			padding: $input-inner-padding;
			border-top-left-radius: $input-border-radius;
			border-bottom-left-radius: $input-border-radius;
			//background-color: $color-grey-light;
			position: relative;
			width: 1px;
			white-space: nowrap;
		}
		.suffix {
			white-space: nowrap;
		}
		/*.append {*/
		/*	display: table-cell;*/
		/*	vertical-align: middle;*/
		/*	!*border-top: $input-border;*/
		/*	border-right: $input-border;*/
		/*	border-bottom: $input-border;*/
		/*	border-top-right-radius: $input-border-radius;*/
		/*	border-bottom-right-radius: $input-border-radius;*/
		/*	padding: $input-inner-padding;*/
		/*	color: $color-text-faded-low;*/
		/*	//background-color: $color-grey-light;*/
		/*	position: relative;	*!*/
		/*	width: 1px;*/
		/*	white-space: nowrap;*/
		/*}*/
		&-prefix {
			#{$r}__inner {
				padding-left: 40px;
			}
		}
		&-suffix {
			#{$r}__inner {
				padding-right: 40px;
			}
		}
		&-prepend {
			display: inline-table;
			border-collapse: separate;
			#{$r}__inner {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
		}
		&-append {
			display: inline-table;
			border-collapse: separate;
			#{$r}__inner {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}

	.textarea {
		.inner {
			@include form-input-default();
			padding: 5px 15px;
			height: auto;
			line-height: 1.5;
			resize: vertical;
			width: 100%;
			&[disabled] {
				cursor: no-drop;
				background-color: $color-grey-light;
			}
		}
	}
</style>
